<template>
<v-card outlined class="bg_none">
    <v-card-title class="text-primary text-center text-h5 font-weight-black">ESTADO DEL HARDWARE DEL OINK</v-card-title>
    <v-divider></v-divider>
    <v-row justify="center" align="center">
        <v-col cols="12" v-if="this.lastUpdate">
            <h5 class="text-primary text-center text-p font-weight-black">ÚLTIMA ACTUALIZACIÓN</h5>
            <span>{{getDate(this.lastUpdate)}}</span>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
            <h5 class="text-primary text-center text-p font-weight-black">RAM</h5>
            <doughnut-chart v-if="ram.datasets[0].data" :chart-data="ram" :options="null" />
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
            <h5 class="text-primary text-center text-p font-weight-black">CPU</h5>
            <doughnut-chart v-if="cpu.datasets[0].data" :chart-data="cpu" :options="null" />
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
            <h5 class="text-primary text-center text-p font-weight-black">DISCO DURO</h5>
            <doughnut-chart v-if="disk.datasets[0].data" :chart-data="disk" :options="null" />
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
            <h5 class="text-primary text-center text-p font-weight-black">TEMPERATURA</h5>
            <doughnut-chart v-if="temp.datasets[0].data" :chart-data="temp" :options="null" />
        </v-col>
    </v-row>
</v-card>
</template>

<script>
import ApiService from '../../../libs/apiService';
import doughnut from '../charts/doughnut.js';
export default {
    name: 'Diagrams',
    props: ['id'],
    components: {
        'doughnut-chart': doughnut
    },
    data() {
        return {
            loading: false,
            lastUpdate: null,
            ram: {
                labels: ['Usado', 'Disponible'],
                datasets: [{
                    label: 'RAM',
                    backgroundColor: ['#ff4444 ', '#4caf50'],
                    data: null
                }]
            },
            cpu: {
                labels: ['Usado', 'Disponible'],
                datasets: [{
                    label: 'CPU',
                    backgroundColor: ['#ff4444 ', '#4caf50'],
                    data: null
                }]
            },
            disk: {
                labels: ['Usado', 'Disponible'],
                datasets: [{
                    label: 'DISCO',
                    backgroundColor: ['#ff4444 ', '#4caf50'],
                    data: null
                }]
            },
            temp: {
                labels: ['Usado', 'Disponible'],
                datasets: [{
                    label: 'TEMPERATURA',
                    backgroundColor: ['#ff4444 ', '#4caf50'],
                    data: null
                }]
            }
        }
    },
    methods: {
        async getStatus() {
            this.loading = true;
            const apiService = new ApiService();
            const req = {
                piggy_bank_id: this.id
            };
            apiService.post('/piggybank/piggybankstatuslist', req, true).then((res) => {
                this.loading = false;
                if (res) {
                    const data = JSON.parse(res);
                    const date = data[13].status[0].status_date;
                    this.lastUpdate = date;
                    let status = data[13].status[0].status_message.replace(/'/g, '"');
                    status = JSON.parse(status);
                    this.ram.datasets[0].data = [status.ram_used, (100 - status.ram_used)];
                    this.cpu.datasets[0].data = [parseFloat(status.cpu_used), (100 - parseFloat(status.cpu_used))];
                    this.disk.datasets[0].data = [status.disk_used, (100 - status.disk_used)];
                    this.temp.datasets[0].data = [status.temp, (100 - status.temp)];
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
            });
        },
        getDate(d) {
            const date = d.split('T');
            return `${date[0]}, ${this.getTime(date[1])}`;
        },
        getTime(time) {
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
                time = time.slice(1); // Remove full string match value
                time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join('');
        }
    },
    mounted() {
        setTimeout(() => {
            this.getStatus();
        }, 100);

    },
}
</script>
